import { Divider, Group, Stack } from '@mantine/core';
import type { OrganizationResponse } from '../../../../api/organization-client/organization-client.type';
import { Button } from '../../../../ui-library/button/button';
import { Icon } from '../../../../ui-library/icon/icon';
import { Text } from '../../../../ui-library/typography/typography';

type Props = {
  organizations: OrganizationResponse[];
  onSelect: (organizationId: string) => void;
};

export const OrganizationList = ({ organizations, onSelect }: Props) => {
  const sortedOrganizations = [...(organizations ?? [])].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
  );

  return (
    <Stack gap={24}>
      <Divider />
      {sortedOrganizations.map((org) => (
        <Stack key={org.id}>
          <Group justify="space-between">
            <Group gap={16}>
              <Icon name="domain" size={24} />
              <Text lineHeight="none" weight="bold">
                {org.name}
              </Text>
            </Group>
            <Button onClick={() => onSelect(org.id)} radius="xl">
              Select
            </Button>
          </Group>
          <Divider />
        </Stack>
      ))}
    </Stack>
  );
};
